import React from 'react';
import { Modal, Box, Typography, Divider, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

export default function ModalDetalleTraspaso({ showModal, handleCloseModal, traspasoSeleccionado, detalles }) {
    return (
        <Modal open={showModal} onClose={handleCloseModal} aria-labelledby="modal-titulo" aria-describedby="modal-descripcion">
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 600,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    maxHeight: '80vh', // Limitar altura máxima
                    overflow: 'auto', // Hacer que el contenido sea desplazable
                }}
            >
                <Typography id="modal-titulo" variant="h6" gutterBottom>
                    Detalles del Traspaso #{traspasoSeleccionado?.idTraspaso}
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <TableContainer component={Paper}>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell><strong>Fecha de Envío</strong></TableCell>
                                <TableCell>{traspasoSeleccionado?.fecha_envio}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><strong>Usuario</strong></TableCell>
                                <TableCell>{traspasoSeleccionado?.usuario}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><strong>Origen</strong></TableCell>
                                <TableCell>{traspasoSeleccionado?.origen}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><strong>Destino</strong></TableCell>
                                <TableCell>{traspasoSeleccionado?.destino}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                <Typography variant="h6" sx={{ mt: 2 }}>Productos en el Traspaso</Typography>
                {detalles.length > 0 ? (
                    <TableContainer component={Paper} sx={{ mt: 2 }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>#</TableCell>
                                    <TableCell>Descripción</TableCell>
                                    <TableCell>EPC</TableCell>
                                    <TableCell>Ubicación Actual</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {detalles.map((detalle, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{detalle.producto}</TableCell>
                                        <TableCell>{detalle.epc}</TableCell>
                                        <TableCell>{detalle.ubicacion_actual}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : (
                    <Typography sx={{ mt: 2 }}>No hay detalles disponibles.</Typography>
                )}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                    <Button variant="contained" color="primary" onClick={handleCloseModal}>
                        Cerrar
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
}
